import Vue from 'vue'

import GooglePlacesAutocompletePlugin from 'vue-better-google-places-autocomplete'
Vue.use(GooglePlacesAutocompletePlugin)
